import React, { Fragment, useEffect } from 'react';
import { styled } from 'styled-components';
import { useShowSearch } from './hooks/use-show-search';
import { MediaResults } from './MediaResults/MediaResults';
import { mobileSearchHeaderHeight } from './SearchBar/SearchBar.styles';
import { useSearchDispatch, useSearchState } from './SearchContext';
import { SearchSuggestion } from './SearchSuggestion';
import { ShowResults } from './ShowResults/ShowResults';
import { useMediaSearch } from '../../../../play-core/api/media-search/use-media-search';
import { Viewports } from '../../../../play-core/styles/Viewports';
import { mobileHeaderHeight } from '../../components/Header/Header.globals';
import { useLoadingBar } from '../../components/LoadingBar/LoadingBarProvider';
import { LoadMore } from '../../components/LoadMore/LoadMore';
import { ErrorFallback } from '../../components/Message/ErrorFallback';
import { useVideoConfig } from '../../config/VideoAppContext';
import { useAxios } from '../../hooks/use-axios';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SearchPage = ({
  initialData: {
    search
  }
}) => {
  const {
    search: config
  } = useVideoConfig();
  const axios = useAxios();
  const {
    query,
    showAll,
    hideShowSearch,
    mediaResult = search?.mediaResult,
    mediaLoading,
    showResult = search?.showResult,
    showsLoading,
    showsFailed,
    previousPage
  } = useSearchState();
  const dispatch = useSearchDispatch();
  useShowSearch();
  const {
    result,
    isLoading,
    loadMore,
    canLoadMore,
    error
  } = useMediaSearch(axios, query, showAll, 'VIDEO');
  useEffect(() => result && dispatch({
    type: 'search-media-success',
    result
  }), [dispatch, result]);
  useEffect(() => dispatch({
    type: 'set-media-loading',
    isLoading
  }), [dispatch, isLoading]);
  useLoadingBar(isLoading);
  const mediaResults = mediaResult?.results ?? [];
  const firstMediasLoading = mediaResult === undefined || mediaLoading && mediaResults.length === 0;
  const shows = showResult?.results ?? [];
  const firstShowsLoading = showResult === undefined || showsLoading && showResult === undefined;
  const showResultsVisible = !showsFailed && !hideShowSearch && config.showSearchSupported && !!query.searchTerm && !!(firstShowsLoading || showResult && showResult.total > 0);
  const suggestion = mediaResult && mediaResult.suggestion;
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(SearchBarPlaceholder, {}), /*#__PURE__*/_jsx(SearchSuggestion, {
      suggestion: suggestion,
      onClick: () => dispatch({
        type: 'search',
        query: suggestion || ''
      })
    }), showResultsVisible && /*#__PURE__*/_jsx(ShowResults, {
      searchTerm: query.searchTerm,
      shows: shows
    }), /*#__PURE__*/_jsx(ErrorFallback, {
      hasError: error,
      children: /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx(MediaResults, {
          showAll: showAll,
          mediaResult: mediaResult,
          order: query.order,
          showFilters: config.filtersSupported,
          isLoading: firstMediasLoading,
          query: query,
          previousPage: previousPage
        }), canLoadMore && !isLoading && /*#__PURE__*/_jsx(LoadMore, {
          onClick: loadMore
        })]
      })
    })]
  });
};
const SearchBarPlaceholder = styled.div.withConfig({
  displayName: "SearchPage__SearchBarPlaceholder",
  componentId: "sc-dagawz-0"
})(["", "{min-height:", "px;}"], Viewports.for('small'), mobileSearchHeaderHeight - mobileHeaderHeight);